import { Link } from "react-router-dom";
import { useState } from "react";

import Button from "../../../../../ReusableComponent/Button";
import LearningPathCard from "../../../../../ReusableComponent/LearningPathCard";
import TrackLearningPlan from "../../../../../ReusableComponent/TrackLearningPlan/TrackLearningPlan";

const ChoosePathDetailsPage = () => {
  const [selectedTrack, setSelectedTrack] = useState(null);
  const [showTrackPlan, setShowTrackPlan] = useState(false);
  
  const learningPaths = [
    {
      title: "Software Engineer Track",
      duration: "12 weeks",
      modules: 5,
      learn: [
        "Data Structures Fundamentals",
        "Algorithm Design & Analysis",
        "System Design Basics",
      ],
      features: [
        "1:1 Mentor Sessions",
        "Live Coding Sessions",
        "Company-specific Prep",
      ],
      //New data for TrackLearningPlan.jsx
      subtitle: "Your personalized roadmap to becoming a software engineer",
      stats: [
        { value: "12 weeks", label: "Total Duration",  bg: "bg-gradient-primary" },
        { value: "5", label: "Modules",  bg: "bg-success" },
        { value: "0%", label: "Completed", bg: "bg-info" },
        { value: "5", label: "Mentors", bg: "bg-warning"},
      ],
      modulesList: [
        { title: "Data Structures Fundamentals", duration: "2 weeks", progress: 0 },
        { title: "Algorithm Design & Analysis", duration: "2 weeks", progress: 0 },
        { title: "System Design Basics", duration: "3 weeks", progress: 0 },
        { title: "Coding Interview Practice", duration: "3 weeks", progress: 0 },
        { title: "Mock Interviews", duration: "2 weeks", progress: 0 },
      ],
      premiumFeatures: [
        "1:1 Mentor Sessions",
        "Live Coding Sessions",
        "Company-specific Prep",
        "Resume Review",
        "Placement Assistance",
      ],
      premiumButtonText: "Start Learning Now",
      mentor: {
        title: "Your Mentor",
        name: "Sarah Johnson",
        role: "Senior SDE @ Google",
        image: "/api/placeholder/80/80",
        rating: 5,
      },
    },
    {
      title: "Data Scientist Track",
      duration: "10 weeks",
      modules: 5,
      learn: [
        "Statistics & Probability",
        "Machine Learning Algorithms",
        "Python for Data Science",
      ],
      features: [
        "Real-world Projects",
        "Industry Datasets",
        "ML Model Deployment",
      ],
      // New data for TrackLearningPlan.jsx
      subtitle: "Your personalized roadmap to becoming a data scientist",
      stats: [
        { value: "10 weeks", label: "Total Duration", bg: "gradient" },
        { value: "5", label: "Modules", bg: "green" },
        { value: "0%", label: "Completed", bg: "blue" },
        { value: "5", label: "Mentors", bg: "yellow" },
      ],
      modulesList: [
        { title: "Statistics & Probability", duration: "2 weeks", progress: 0 },
        { title: "Machine Learning Algorithms", duration: "3 weeks", progress: 0 },
        { title: "Python for Data Science", duration: "2 weeks", progress: 0 },
        { title: "SQL & Database Design", duration: "2 weeks", progress: 0 },
        { title: "Portfolio Projects", duration: "1 week", progress: 0 },
      ],
      premiumFeatures: [
        "Real-world Projects",
        "Industry Datasets",
        "ML Model Deployment",
        "Data Visualization",
        "Career Guidance",
      ],
      premiumButtonText: "Start Learning Now",
      mentor: {
        title: "Your Mentor",
        name: "Michael Chen",
        role: "Senior Data Scientist @ Google",
        image: "/api/placeholder/80/80",
        rating: 5,
      },
    },
  ];

  const selectedPathData = learningPaths.find(
    (path) => path.title === selectedTrack
  );

  return (
    <div className="row mx-0 my-5 py-5 d-flex justify-content-center">
      <div className="col-md-11 col-12">
        {!showTrackPlan ? (
          <>
            <div className="row mx-0 d-flex justify-content-center align-items-center">
              <div className="row mx-0 d-flex justify-content-start">
                <div className="col-12">
                  <Link to="/placement">
                    <Button variant="back">← Back to Placement Prep</Button>
                  </Link>
                </div>
              </div>
              <div className="col-12 text-center mb-5">
                <h2 className="text-center text-light mb-3 fw-bold">
                  Choose Your Learning Path
                </h2>
                <p className="text-center text-light mb-0">
                  Select a track that matches your career goals
                </p>
              </div>
              {learningPaths.map((path, index) => (
                <div
                  key={index}
                  className="col-md-6 mb-4"
                  onClick={() => setSelectedTrack(path.title)}
                >
                  <LearningPathCard key={index} {...path} />
                </div>
              ))}
            </div>
            {/* Show Continue Button only if selected */}
            {selectedTrack && (
              <div className="text-center mt-4">
                <Button variant="gradient" onClick={() => setShowTrackPlan(true)} >
                  Continue with {selectedTrack} Level
                </Button>
              </div>
            )}
          </>
        ) : (
          <TrackLearningPlan
            title={selectedPathData.title}
            subtitle={selectedPathData.subtitle}
            stats={selectedPathData.stats}
            modules={selectedPathData.modulesList}
            premiumFeatures={selectedPathData.premiumFeatures}
            premiumButtonText={selectedPathData.premiumButtonText}
            mentor={selectedPathData.mentor}
            onBackToPrep={() => {
              setShowTrackPlan(false);
              setSelectedTrack(null);
            }}
            onBackToTracks={() => setShowTrackPlan(false)}
          />
        )}
      </div>
    </div>
  );
};

export default ChoosePathDetailsPage;